export default "__VITE_ASSET__C7NaQ4_t__"